<template>
	<table>
		<caption>Carrier Information</caption>
		<thead>
			<tr>
				<th>Name</th>
				<th>Additional Scanning Information</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>{{ carrierName }}</td>
				<td>
					<a v-if="trackingPage" :href="trackingPage.replace('{connote}', consignmentNote)" target="_blank">Tracking Link</a>
					<span v-else>N/A</span>
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
	export default {
		props: {
			carrierName: String,
			trackingPage: String,
			consignmentNote: String
		}
	}
</script>